import '../../assets/index13.css';var w = Object.defineProperty, A = Object.defineProperties;
var C = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
var u = (t, e, o) => e in t ? w(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, m = (t, e) => {
  for (var o in e || (e = {}))
    d.call(e, o) && u(t, o, e[o]);
  if (n)
    for (var o of n(e))
      f.call(e, o) && u(t, o, e[o]);
  return t;
}, p = (t, e) => A(t, C(e));
var S = (t, e) => {
  var o = {};
  for (var r in t)
    d.call(t, r) && e.indexOf(r) < 0 && (o[r] = t[r]);
  if (t != null && n)
    for (var r of n(t))
      e.indexOf(r) < 0 && f.call(t, r) && (o[r] = t[r]);
  return o;
};
import { jsx as i } from "react/jsx-runtime";
import l from "react";
import { ProgressIndicator as E } from "../ProgressIndicator/index.js";
import { B as V } from "../../Button-D50dlMrD.js";
const W = "Button-module__root___FeqPS", j = "Button-module__loader___4cAeS", q = "Button-module__label___xdOsD", D = "Button-module__section___WtWx0", F = "Button-module__inner___XSRSZ", h = {
  root: W,
  loader: j,
  label: q,
  section: D,
  inner: F
}, B = (t) => l.isValidElement(t) ? l.Children.count(t.props.children) === 0 ? 1 : l.Children.toArray(t.props.children).reduce((e, o) => e + B(o), 0) : typeof t == "string" || typeof t == "number" ? t.toString().length : 0, G = l.forwardRef((I, z) => {
  var a = I, {
    children: t,
    size: e = "sm",
    variant: o = "accent",
    classNames: r,
    danger: c = !1,
    leftIcon: s,
    rightIcon: _,
    leftSection: g,
    rightSection: y,
    loading: b
  } = a, x = S(a, [
    "children",
    "size",
    "variant",
    "classNames",
    "danger",
    "leftIcon",
    "rightIcon",
    "leftSection",
    "rightSection",
    "loading"
  ]);
  const P = s ? /* @__PURE__ */ i(s, { size: 14 }) : g, R = _ ? /* @__PURE__ */ i(_, { size: 14 }) : y;
  return /* @__PURE__ */ i(
    V,
    p(m({
      classNames: r != null ? r : h
    }, x), {
      ref: z,
      mod: {
        "data-icon-only": B(t) === 1,
        size: e,
        "data-design-variant": o,
        "data-dangerous": c
      },
      leftSection: P,
      rightSection: R,
      loading: b,
      loaderProps: {
        children: /* @__PURE__ */ i(
          E,
          {
            className: h.loader,
            size: 16,
            color: c ? "red" : o === "accent" ? "white" : o === "ai-primary" || o === "ai-secondary" ? "brass" : "violet"
          }
        )
      },
      children: t
    })
  );
});
export {
  G as Button
};
